import React from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, FormProvider, useForm } from "react-hook-form";

import ContentSection from "../ContentSection";
import Button from "../core/Button/Button";
import InputText from "../core/Form/InputText";

import { ReactComponent as KeyHome } from "../../../assets/images/habitacional/KeyHome-Image.svg";

import useWindowSize from "../../../hooks/useWindowSize";
import useAuthToken from "../../../hooks/requests/useAuthToken";

const formSchema = yup.object().shape({
  SearchForCompensation: yup.string().required("Campo obrigatório."),
});

const CtaTrakingYourClaimWithCpf = () => {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;
  const defaultDescription =
    "Informe o número do pedido de indenização (sinistro) ou CPF do titular do contrato e confira como está o andamento do processo.";

  const { refreshToken } = useAuthToken();

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: yupResolver(formSchema),
  });

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = methods;

  const removeMask = (value) => {
    if (!value) {
      return "";
    }

    return value.replace(/\D/g, "");
  };

  const currentMask =
    removeMask(watch("SearchForCompensation"))?.length === 11
      ? "999.999.999-999"
      : "999999999999999999999999";

  async function onSubmit(data) {
    const valueWithoutMask = removeMask(data.SearchForCompensation);

    await refreshToken();
    window.open(
      `/paravoce/habitacional/acompanhar-pedidos/${valueWithoutMask}`,
      "_ blank"
    );
  }

  return (
    <ContentSection
      id="acompanhamento-sinistro"
      reverse
      illustration={isDesktop ? <KeyHome /> : undefined}
      title="Acompanhe o andamento do seu pedido de indenização (sinistro)"
      description={defaultDescription}
    >
      <FormProvider {...methods}>
        <form style={{ marginTop: "40px" }} onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="SearchForCompensation"
            control={control}
            render={({ field }) => (
              <InputText
                id="SearchForCompensation"
                name="SearchForCompensation"
                title="Digite o número do pedido ou CPF do titular"
                placeholder="Número do pedido ou CPF"
                hasError={errors?.SearchForCompensation?.message}
                errorMessage={errors?.SearchForCompensation?.message}
                value={field.value}
                mask={currentMask}
                maskChar={null}
                onChange={(e) => {
                  field.onChange(e.target.value);
                }}
                isRequired
                {...field}
              />
            )}
          />
          <Button type="submit" variant="primary" style={{ marginTop: "32px" }}>
            Consultar
          </Button>
        </form>
      </FormProvider>
    </ContentSection>
  );
};

export default CtaTrakingYourClaimWithCpf;
